import { ShoppingCartProvider } from '@seek/shopping-cart-provider';

import {
  Classify,
  SelectAdType,
  Write,
  Manage,
  Create,
  Refresh,
  Edit,
  EditPayAndPost,
  MultiLocation,
  RefreshError,
  PayAndPost,
  Success,
} from 'src/app/v1/views/pages';

import {
  ROUTE_CLASSIFY,
  ROUTE_CONCIERGE,
  ROUTE_CREATE,
  ROUTE_EDIT,
  ROUTE_EDIT_PAY_AND_POST,
  ROUTE_EDIT_SUCCESS,
  ROUTE_GUARANTEED_HIRE,
  ROUTE_MANAGE,
  ROUTE_MULTI_LOCATION,
  ROUTE_PAY_AND_POST,
  ROUTE_PAY_AND_POST_V2,
  ROUTE_PREMIUM_PLUS,
  ROUTE_REFRESH,
  ROUTE_REFRESH_ERROR,
  ROUTE_REFRESH_SUCCESS,
  ROUTE_SELECT_AD_TYPE,
  ROUTE_SUCCESS,
  ROUTE_WRITE,
} from '../shared/constants/routes';
import { log } from '../utils/logging';
import CreateFlowContainer from '../v1/views/containers/CreateFlowContainer';
import EditFlowContainer from '../v1/views/containers/EditFlowContainer';
import MultiLocationContainer from '../v1/views/containers/MultiLocationContainer';
import RefreshFlowContainer from '../v1/views/containers/RefreshFlowContainer';
import {
  Concierge,
  GuaranteedHire,
  PremiumPlus,
} from '../v1/views/pages/JobAdBooking';
import { CreateFlowContainerV2 } from '../v2/containers/CreateFlowContainer/createFlowContainerV2';
import { PayAndPostPageV2 } from '../v2/pages/PayAndPostV2';

interface Route {
  id: string;
  route: string;
  version: 1 | 2;
  element: JSX.Element;
}

export const routes: Route[] = [
  {
    id: ROUTE_CREATE,
    route: ROUTE_CREATE,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <Create />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_CLASSIFY,
    route: ROUTE_CLASSIFY,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <Classify />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_SELECT_AD_TYPE,
    route: ROUTE_SELECT_AD_TYPE,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <SelectAdType />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_WRITE,
    route: ROUTE_WRITE,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <Write />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_MANAGE,
    route: ROUTE_MANAGE,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <Manage />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_CONCIERGE,
    route: ROUTE_CONCIERGE,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <Concierge />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_GUARANTEED_HIRE,
    route: ROUTE_GUARANTEED_HIRE,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <GuaranteedHire />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_PREMIUM_PLUS,
    route: ROUTE_PREMIUM_PLUS,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <PremiumPlus />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_PAY_AND_POST,
    route: ROUTE_PAY_AND_POST,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <PayAndPost />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_PAY_AND_POST_V2,
    route: ROUTE_PAY_AND_POST_V2,
    version: 2,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainerV2>
          <PayAndPostPageV2 />
        </CreateFlowContainerV2>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_SUCCESS,
    route: ROUTE_SUCCESS,
    version: 1,
    element: (
      <ShoppingCartProvider
        createProductSetId="CreateProductSetForAdPosting"
        useMockCart={false}
        logger={log}
      >
        <CreateFlowContainer>
          <Success />
        </CreateFlowContainer>
      </ShoppingCartProvider>
    ),
  },
  {
    id: ROUTE_EDIT,
    route: ROUTE_EDIT,
    version: 1,
    element: (
      <EditFlowContainer>
        <Edit />
      </EditFlowContainer>
    ),
  },
  {
    id: ROUTE_EDIT_PAY_AND_POST,
    route: ROUTE_EDIT_PAY_AND_POST,
    version: 1,
    element: (
      <EditFlowContainer>
        <EditPayAndPost />
      </EditFlowContainer>
    ),
  },
  {
    id: ROUTE_EDIT_SUCCESS,
    route: ROUTE_EDIT_SUCCESS,
    version: 1,
    element: (
      <EditFlowContainer>
        <Success />
      </EditFlowContainer>
    ),
  },
  {
    id: ROUTE_REFRESH,
    route: ROUTE_REFRESH,
    version: 1,
    element: (
      <RefreshFlowContainer>
        <Refresh />
      </RefreshFlowContainer>
    ),
  },
  {
    id: ROUTE_REFRESH_SUCCESS,
    route: ROUTE_REFRESH_SUCCESS,
    version: 1,
    element: (
      <RefreshFlowContainer>
        <Success />
      </RefreshFlowContainer>
    ),
  },
  {
    id: ROUTE_REFRESH_ERROR,
    route: ROUTE_REFRESH_ERROR,
    version: 1,
    element: (
      <RefreshFlowContainer>
        <RefreshError />
      </RefreshFlowContainer>
    ),
  },
  {
    id: ROUTE_MULTI_LOCATION,
    route: ROUTE_MULTI_LOCATION,
    version: 1,
    element: (
      <MultiLocationContainer>
        <MultiLocation />
      </MultiLocationContainer>
    ),
  },
];
